import type React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TemporaryTokenManager } from '@cobliteam/api-lib/src/account/cobler/TemporaryTokenManager';
import { AuthToken } from '@cobliteam/api-lib/src/account/session/AuthToken';

import { type AppState, loginSucceeded } from '@cobliteam/store';

interface PublicRouterProviderProps {
  children: React.ReactNode;
}

const PublicRouterProvider = ({ children }: PublicRouterProviderProps) => {
  const dispatch = useDispatch();
  const session = useSelector((state: AppState) => state.login.session);

  const temporaryToken = TemporaryTokenManager.getTemporaryToken();
  if (temporaryToken) {
    localStorage.setItem(AuthToken.ACCESS_TOKEN, temporaryToken);

    const newSession =
      TemporaryTokenManager.buildSessionFromTemporaryToken(temporaryToken);

    if (session?.id !== newSession.id) dispatch(loginSucceeded(newSession));
  }

  const authToken = localStorage.getItem(AuthToken.ACCESS_TOKEN);
  if (authToken) return null;

  return children;
};

export default PublicRouterProvider;
